import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Card, CardContent } from "../ui/card";
import { Copy } from "lucide-react";

export function InvoiceDetailItem({
  label,
  formId,
  ourValue,
  ocrValue,
  value, // Controlled value için yeni prop
  onAccept,
  onInputChanged,
  isApproved,
  hideClient,
  hideMatch,
  disableAccept = false,
  showCopyButton = false,
}) {
  return (
    <Card className="flex items-center p-0 invoice-detail-item hover:shadow-sm transition-shadow">
      <CardContent className="flex item-center justify-between p-1 w-full">
        <div className=" flex flex-col w-full  ">
          {!hideClient && (
            <div className="flex  gap-3 items-center">
              <div className="flex  items-center gap-1  ">
                <div className="w-3 h-3 bg-green-500 rounded"></div>
                <Label className="w-[100px] block text-foreground text-sm font-bold ">
                  {label}
                </Label>
              </div>
              <div className="flex w-full items-center gap-2">
                <Label className="p-2 px-3">{ourValue}</Label>
                {showCopyButton && (
                  <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    onClick={() => {
                      if (onInputChanged) {
                        onInputChanged(ourValue);
                      }
                    }}
                    className="h-7 w-7 text-muted-foreground hover:text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-950"
                    title="Aşağıya kopyala"
                  >
                    <Copy className="h-4 w-4" />
                  </Button>
                )}
              </div>
            </div>
          )}

          <div className="flex gap-3 items-center ">
            <div className="flex  items-center gap-1   ">
              <div className="w-3 h-3 bg-red-500 rounded"></div>
              <Label className="w-[100px]  block text-foreground text-sm font-bold  ">
                {label}
              </Label>
            </div>

            <div className="flex w-full">
              <input
                className="flex-1 shadow appearance-none border rounded text-sm p-2 px-3 text-foreground leading-tight focus:outline-none focus:shadow-outline bg-background focus:border-blue-400 transition-colors"
                type="text"
                onChange={(e) => {
                  onInputChanged(e.target.value);
                  console.log(e.target.value);
                }}
                value={value !== undefined ? value : ocrValue}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-1 items-center m-1 justify-between">
          {!hideMatch &&
            (ocrValue === ourValue ? (
              <Badge variant="success">Eşleşti</Badge>
            ) : (
              <Badge variant="destructive">Değil </Badge>
            ))}

          {isApproved ? (
            <Badge variant="success">Onaylandı</Badge>
          ) : (
            <Button
              type="button"
              onClick={onAccept}
              disabled={disableAccept}
              variant={disableAccept ? "secondary" : "default"}
              className={disableAccept ? "opacity-50 cursor-not-allowed" : ""}
            >
              Kabul Et
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
